export const theme = {
  colors : {
    primary: "#FF5733",
    secondary: "#33C1FF",
    background: "#F0F0F0",
    text: "#333333",
    border: "#E0E0E0",
  },
}